<template>
    <modal-live ref="modal">
        <div class="dialog">
            <h2 class="headline--welcome text-center">Licenses</h2>
            <div class="modal-scrollable">
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Eius ut error neque quod voluptate hic iusto rem
                    exercitationem recusandae perferendis sequi possimus dicta
                    enim repellat veritatis fugiat deleniti ipsa minus vero, ad
                    pariatur distinctio corrupti amet aliquid! Obcaecati sequi
                    cumque mollitia! Ducimus nam nesciunt excepturi totam hic
                    blanditiis tenetur aperiam.
                </p>
                <p>
                    Maiores rem eaque mollitia nobis fugiat, sed quod accusamus
                    beatae quaerat a quasi itaque id. Ullam doloribus et sequi
                    aut error suscipit nostrum eius, molestiae ipsum voluptas.
                    At tenetur dignissimos, repudiandae voluptate possimus
                    labore qui nihil nobis pariatur rerum, nam sapiente
                    repellendus nesciunt assumenda quam? Consequuntur cupiditate
                    ea repellat porro?
                </p>
                <p>
                    Veniam assumenda voluptatum consequuntur minus cum magnam,
                    vel sapiente dolor laboriosam ullam aut necessitatibus
                    eligendi nihil, non labore dicta impedit ducimus quibusdam
                    expedita maiores nemo neque voluptate cupiditate quos! Ea
                    fuga ad tempora assumenda, voluptatibus laudantium labore
                    eaque accusantium repellat incidunt consectetur praesentium
                    facere sed, unde autem. Sit, sed eligendi.
                </p>
            </div>
            <div class="text-center pt-3">
                <Button @click.native="dismiss()"> I agree </Button>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    methods: {
        dismiss() {
            this.$refs.modal.dismiss();
        },
    },
};
</script>

<style lang="scss"></style>
